import React from 'react';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import $ from 'jquery';
import {
  normalizeChildDatasetName
} from '../../utils/attribute_name_utils';

class DiscoverForm extends React.Component {
    constructor(props) {
        super(props);
        this.changeEnvironment = this.changeEnvironment.bind(this);
        this.changeDataSource = this.changeDataSource.bind(this);
        this.changeDataset = this.changeDataset.bind(this);
        this.changeAttribute = this.changeAttribute.bind(this);
        let environmentOptions = []
        let datasourceOptions = []
        let datasetOptions = []
        let attributeOptions = []
        let preSelectedDatasource = this.props.preSelectedDatasource
        let preSelectedEnv = this.props.preSelectedEnv
        let preSelectedDataset = this.props.preSelectedDataset
        let preSelectedAttribute = this.props.preSelectedAttribute
        let envId;
        let datasourceId;
        let datasetId;

        for(let [key, value] of Object.entries(this.props.nestedData)){
           environmentOptions.push({"label": value["title"], "value": key});
        }
         let environment = this.props.envCount
         
        //  if(environment === null) {
        //     let filteredEnvironment = this.props.filterResultData.filter(value => {
        //         return value.type === "Environment";
        //     });
        //     environment = filteredEnvironment.length
        //  }else {
          
              // envId = preSelectedEnv["value"]              
              envId = this.props.selectedEnvId !== null ? this.props.selectedEnvId : this.props.latest_env_id;
              let dataSources = this.props.nestedData !==undefined && this.props.nestedData[envId] !==undefined && this.props.nestedData[envId]["childNodes"];
              for(let [key, value] of Object.entries(dataSources)){
                datasourceOptions.push({"label": value["title"], "value": key});
             } 
        //  }
         
         let datasource = this.props.datasourceCount
         if(datasource === null){
            let filterDatasource = this.props.filterResultData.filter(value => {
                return value.type === "Datasource";
            });
            datasource = filterDatasource.length
         }else if(preSelectedDatasource) {
              datasourceId = preSelectedDatasource["value"]
              let datasets = this.props.nestedData !== undefined && this.props.nestedData[envId] !== undefined && this.props.nestedData[envId]["childNodes"] !== undefined &&  this.props.nestedData[envId]["childNodes"][datasourceId] !==undefined && this.props.nestedData[envId]["childNodes"][datasourceId]["childNodes"]
              for(let [key, value] of Object.entries(datasets)){
                  datasetOptions.push({ "label": normalizeChildDatasetName(value["title"]), "value": key });
              }
         }
         let dataset = this.props.datasetCount
         if(dataset === null){
            let filteredDataset = this.props.filterResultData.filter(value => {
                return value.type === "Dataset";
           });
           dataset = filteredDataset.length

         }else if(preSelectedDataset){
             datasetId = preSelectedDataset["value"]
             let attributes = this.props.nestedData !== undefined && this.props.nestedData[envId] !== undefined && this.props.nestedData[envId]["childNodes"] !== undefined &&  this.props.nestedData[envId]["childNodes"][datasourceId] !==undefined && this.props.nestedData[envId]["childNodes"][datasourceId]["childNodes"] !== undefined && this.props.nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId] !== undefined && this.props.nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]["childNodes"]
             for(let [key, value] of Object.entries(attributes)){
                attributeOptions.push({"label": value["title"], "value": key});
              }
         }
         let attribute = this.props.attributeCount
         if(attribute === null) {
            let filteredAttribute = this.props.filterResultData.filter(value => {
                return value.type === "Attribute";
              });
              attribute = filteredAttribute.length
         }


        this.state={
            environmentOptions:environmentOptions,
            datasetOptions: datasetOptions,
            datasourceOptions: datasourceOptions,
            attributeOptions: attributeOptions,
            selectedDatasource: preSelectedDatasource,
            selectedDataset: preSelectedDataset,
            selectedAttribute: preSelectedAttribute,
            selectedEnv: preSelectedEnv,
            totalenvironment:environment,
            totaldataset:dataset,
            totaldatasource:datasource,
            totalattibute:attribute
        }
    }

    changeEnvironment(event) {
         let envId = event.value;
         let dataSources = this.props.nestedData[envId]

         let datasourceOptions = []
         if(dataSources !== undefined){
           dataSources = dataSources["childNodes"]
           for(let [key, value] of Object.entries(dataSources)){
                datasourceOptions.push({"label": value["title"], "value": key});
           }
           this.props.applyFilter("Environment", event);



           let datasource = this.props.filterResultData.filter(value => {
             return value.type === "Datasource" && value.envId.toLowerCase().slice(0, envId) === envId;
           });
           let dataset = this.props.filterResultData.filter(value => {
             return value.type === "Dataset" && value.envId.toLowerCase().slice(0, envId) === envId;
           });
           let attribute = this.props.filterResultData.filter(value => {
             return value.type === "Attribute" && value.envId.toLowerCase().slice(0, envId) === envId;
           });
           this.props.changeCount(1, datasource.length, dataset.length, attribute.length)

           this.setState({datasourceOptions: datasourceOptions,
                          selectedDatasource: null,
                          selectedDataset: null,
                          selectedAttribute: null,
                          datasetOptions: [],
                          attributeOptions: [],
                          selectedEnv: event,
                          totalenvironment: 1,
                          totaldataset:dataset.length,
                          totaldatasource:datasource.length,
                          totalattibute:attribute.length
                        });
         }
         $("#filtericon").hide();
         $(".filter-count").html(1);
         $(".filter-count").show();
         $("#btn-filter").addClass("active");
    }
    changeDataSource(event) {
          let envId = this.props.selectedEnvId !== null ? this.props.selectedEnvId : this.props.latest_env_id;          
          let datasourceId = event.value;
          let datasetOptions = []
          let datasets = this.props.nestedData[envId]["childNodes"][datasourceId]
          if(datasets !== undefined) {
             datasets = datasets["childNodes"]
             for(let [key, value] of Object.entries(datasets)){
                datasetOptions.push({ "label": normalizeChildDatasetName(value["title"]), "value": key });
             }
            this.props.applyFilter("Datasource", this.props.selectedEnv !== null ? this.props.selectedEnv.value : this.props.latest_env_id , event)
            let id = "#Datasource-left-panel-div-"
            id = id + "Datasource-" + datasourceId +"Datasource"
            $(id).trigger("click");
        
      let dataset = this.props.filterResultData.filter(value => {
    return value.type === "Dataset" &&
        typeof value.datasourceId === "string" &&
        value.datasourceId.toLowerCase().slice(0, datasourceId.length) === datasourceId.toLowerCase();
});

let attribute = this.props.filterResultData.filter(value => {
    return value.type === "Attribute" &&
        typeof value.datasourceId === "string" &&
        value.datasourceId.toLowerCase().slice(0, datasourceId.length) === datasourceId.toLowerCase();
});

             this.props.changeCount(1, 1, dataset.length, attribute.length)
             this.setState({datasetOptions: datasetOptions,
                            selectedDatasource: event,
                            selectedDataset: null,
                            attributeOptions: [],
                            selectedAttribute: null,
                            totaldataset:dataset.length,
                            totaldatasource: 1,
                            totalattibute:attribute.length
                        })
          }
          $(".filter-count").html(2);

    }
    changeDataset(event) {
      let envId = this.props.selectedEnvId !== null ? this.props.selectedEnvId : this.props.latest_env_id;
      let datasourceId = this.state.selectedDatasource.value;
          let datasetId = event.value;
          let attributeOptions = []
          let datasets = this.props.nestedData[envId] !== undefined && this.props.nestedData[envId]["childNodes"] !== undefined && this.props.nestedData[envId]["childNodes"][datasourceId] !== undefined && this.props.nestedData[envId]["childNodes"][datasourceId]["childNodes"][datasetId]
          if (datasets && datasets["childNodes"]){             
            datasets = datasets["childNodes"]
             for(let [key, value] of Object.entries(datasets)){
                attributeOptions.push({"label": value["title"], "value": key});
             }
             this.props.applyFilter("Dataset", this.props.selectedEnv !== null ? this.props.selectedEnv.value : this.props.latest_env_id, this.state.selectedDatasource, event)


              const clsName = `Dataset-left-panel-div-Dataset-${datasetId}Dataset`;
              // const targetDiv = document.getElementById(clsName);
              // if (targetDiv) {
              //   // Remove active class from all li elements EXCEPT the one containing div with id 'Dataset-left-panel'
              //   const allLis = document.querySelectorAll('li.active');
              //   allLis.forEach(li => {
              //     const datasetPanelDiv = li.querySelector('#Dataset-left-panel-div-');
              //     if (!datasetPanelDiv) {
              //       li.classList.remove('active');

              //     }
              //   });
          
              //   // Traverse up to find the parent li element of the current target div
              //   let parentLi = targetDiv.parentNode;
              //   while (parentLi && parentLi.tagName !== 'LI') {
              //     parentLi = parentLi.parentNode;
              //   }
          
              //   // Add the 'active' class to the parent li of the current target div
              //   if (parentLi) {
              //     parentLi.classList.add('active');

              //   }
              // }
              $(`div[id^='Dataset-left-panel-div-']`).each(function() {
                let id = $(this).attr('id');
                  if ($("#" + id).is(" .caret.caret-down")) {
                    $("#" + id).trigger("click");
                  }
                  else{
                        $("#" + clsName).trigger("click");
                  }
              });

              let attribute = this.props.filterResultData.filter(value => {
                return value.type === "Attribute" && value.datasetId === datasetId;
              });
              this.props.changeCount(1, 1, 1, attribute.length)

             this.setState({attributeOptions: attributeOptions,
                            selectedDataset: event,
                            selectedAttribute: null,
                            totaldataset:1,
                            totalattibute:attribute.length
                        })
          }
          $(".filter-count").html(3);
    }

    changeAttribute(event) {
         let attributeId = event.value
         this.props.applyFilter("Attribute",this.props.selectedEnv !== null ? this.props.selectedEnv.value : this.props.latest_env_id, this.state.selectedDatasource, this.state.selectedDataset, event)
        let id = "#Attribute-left-panel-div-"
         id = id +"Attribute-" + attributeId +"Attribute"
         $(id).trigger("click");
         this.setState({selectedAttribute: event, totalattibute:1});
         this.props.changeCount(1, 1, 1, 1)
         $(".filter-count").html(4);
         this.props.closeAdvancedFilter();
    }

   
    render() {


      console.log("Discover form render")
      console.log(this.state);
      
       return(<><div className="qd_search-filter-form">
                    <Form className="form-label-right-md" data-select2-id="28">
                    <h4 className="qd_autosuggest-title">Advanced search</h4>
                    <button onClick={this.props.closeAdvancedFilter} type="button" className="btn btn-link">Close</button>
                    <div className="row row-sm" data-select2-id="27">
                        <Form.Group controlId="environment" className="col-6">
                            <Form.Label>Environment :</Form.Label>
                            <Select name="environment"
                                    filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="environment"
                                    options={this.state.environmentOptions}
                                    onChange={this.changeEnvironment}
                                    placeholder={this.state.environmentOptions.find(env => Number(env.value) === Number(this.props.selectedEnvId))?.label}
                                    classNamePrefix='select-control'
                                    value={this.state.selectedEnv}
                                    isDisabled
                            />
                        </Form.Group>
                        <Form.Group controlId="datasource" className="col-6">
                            <Form.Label>Datasource :</Form.Label>
                            <Select name="datasource"
                                    filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="datasource"
                                    options={this.state.datasourceOptions}
                                    onChange={this.changeDataSource}
                                    placeholder="Select Datasource"
                                    classNamePrefix='select-control'
                                    value={this.state.selectedDatasource}
                            />
                        </Form.Group>
                        <Form.Group controlId="dataset" className="col-6">
                            <Form.Label>Dataset :</Form.Label>
                            <Select name="dataset"
                                    filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="dataset"
                                    options={this.state.datasetOptions}
                                    onChange={this.changeDataset}
                                    placeholder="Select Dataset"
                                    classNamePrefix='select-control'
                                    value={this.state.selectedDataset}
                            />
                        </Form.Group>
                        <Form.Group controlId="attribute" className="col-6">
                            <Form.Label>Attributes :</Form.Label>
                            <Select name="attribute"
                                    filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                    id="attribute"
                                    onChange={this.changeAttribute}
                                    options={this.state.attributeOptions}
                                    placeholder="Select Attributes"
                                    classNamePrefix='select-control'
                                    value={this.state.selectedAttribute}
                            />
                        </Form.Group>
                    </div>
                    </Form>
                    <div className="qd_search-rst-footer">
                        <ol className="qd_tab-separated-block">
                        <li className="tab-separated-value"><span><strong>{this.state.environmentOptions.length}</strong> Environment</span></li>
                        <li className="tab-separated-value"><span><strong>{this.state.datasourceOptions.length}</strong> Datasource</span></li>
                        <li className="tab-separated-value"><span><strong>{this.state.datasetOptions.length}</strong> Dataset</span></li>
                        <li className="tab-separated-value"><span><strong>{this.state.attributeOptions.length}</strong> Attributes</span></li>
                        </ol></div>
                        </div></>);




    }
}

export default DiscoverForm;
















